import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../../apiClient'
import { OntologyPredictionCorrection } from './ontologyPredictionCorrectionTypings'

export const USE_ONTOLOGY_PREDICTION_CORRECTION_BY_ID_KEY = 'ontology-prediction-correction-by-id'

type GetOntologyPredictionCorrectionByIdResponse = OntologyPredictionCorrection

type UseGetOntologyPredictionCorrectionById = {
  programId?: string
  predictionCorrectionId?: string
}
export function useGetOntologyPredictionCorrectionById(params: UseGetOntologyPredictionCorrectionById) {
  return useQuery({
    queryKey: [USE_ONTOLOGY_PREDICTION_CORRECTION_BY_ID_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.get<GetOntologyPredictionCorrectionByIdResponse>(
        `/int/v3/programs/${params.programId}/ontology/prediction-corrections/${params.predictionCorrectionId}`
      )
      return data
    },
    enabled: Boolean(params.programId) && Boolean(params.predictionCorrectionId),
    refetchOnWindowFocus: false,
  })
}
